import { ChevronDown } from 'lucide-react';
import { LiksTextFormField } from '../../components/liks/LiksTextFormField/LiksTextFormField';
import { useI18n } from '../../i18n/useI18n';

type CreateLacUserDialogOptionalFieldsProps = {
  optionalFieldsId: string;
  showOptionalFields: boolean;
  onToggleOptionalFields: () => void;
  validFrom: string;
  onValidFromChange: (value: string) => void;
  validTo: string;
  onValidToChange: (value: string) => void;
  isValidToBeforeValidFrom: boolean;
  isSubmitting: boolean;
};

export function CreateLacUserDialogOptionalFields({
  optionalFieldsId,
  showOptionalFields,
  onToggleOptionalFields,
  validFrom,
  onValidFromChange,
  validTo,
  onValidToChange,
  isValidToBeforeValidFrom,
  isSubmitting,
}: CreateLacUserDialogOptionalFieldsProps) {
  const { translate } = useI18n();

  return (
    <>
      <button
        type="button"
        className="lac-create-user__details-toggle"
        aria-expanded={showOptionalFields}
        aria-controls={optionalFieldsId}
        onClick={onToggleOptionalFields}
        disabled={isSubmitting}
      >
        <ChevronDown
          className={[
            'lac-create-user__details-chevron',
            showOptionalFields && 'lac-create-user__details-chevron--expanded',
          ]
            .filter(Boolean)
            .join(' ')}
          strokeWidth={2}
          aria-hidden
        />
        <span>
          {showOptionalFields
            ? translate('lac.users.create.hideOptionalFields')
            : translate('lac.users.create.showOptionalFields')}
        </span>
      </button>

      {showOptionalFields && (
        <div id={optionalFieldsId} className="lac-create-user__optional-fields">
          <div className="lac-create-user__row">
            <LiksTextFormField
              label={translate('lac.users.create.validFromLabel')}
              type="date"
              value={validFrom}
              onChange={onValidFromChange}
              disabled={isSubmitting}
            />

            <LiksTextFormField
              label={translate('lac.users.create.validToLabel')}
              type="date"
              value={validTo}
              onChange={onValidToChange}
              disabled={isSubmitting}
              error={
                isValidToBeforeValidFrom
                  ? translate('lac.users.create.validToBeforeValidFrom')
                  : null
              }
            />
          </div>
        </div>
      )}
    </>
  );
}
